import axios from 'axios';

const bankApi = axios.create({
    baseURL: 'https://brasilapi.com.br/api',
});

export default bankApi;